import { Injectable } from "@angular/core";
import { CookieService } from 'ngx-cookie-service';
@Injectable()
export class CookieManagerService {
  constructor(private cookieService: CookieService) {}

  private defaultPath = "/";

  public setCookie(
    name: string,
    value: string,
    expireDate?: number | Date
  ): void {
    this.cookieService.set(
      name,
      value,
      expireDate || this.getCookieExpireDate(),
      this.defaultPath,
      undefined,
      true
    );
  }

  public deleteCookie(name: string): void {
    this.cookieService.delete(name, this.defaultPath);
  }

  public deleteAllCookies(): void {
    this.cookieService.deleteAll(this.defaultPath);
    sessionStorage.clear();
  }

  private getCookieExpireDate(): Date | undefined {
    const rememberMe = this.cookieService.check("rememberMe");
    const daysToExpire = Number(this.cookieService.get("daysToExpire"));
    const newExpireDate = new Date();
    newExpireDate.setDate(newExpireDate.getDate() + daysToExpire)
    return rememberMe ? newExpireDate : undefined;
  }

  public setCookieExpireDate(rememberMe: boolean, tokenExpireDate: string) {
    const daysToExpire = this.getDifferenceInDays(tokenExpireDate)
    this.setCookie("rememberMe", String(rememberMe), new Date(tokenExpireDate));
    this.setCookie("daysToExpire", String(daysToExpire), new Date(tokenExpireDate));
  }
  
  private getDifferenceInDays(date: string): number {
    const currentDate = new Date();
    const givenDate = new Date(date);
  
    // Calculate the difference in milliseconds
    const differenceInMilliseconds = +givenDate - +currentDate;
  
    // Convert milliseconds to days (1 day = 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
    const differenceInDays = differenceInMilliseconds / (1000 * 3600 * 24);
  
    // Round the number of days to remove the decimal part
    return Math.ceil(differenceInDays);
  }
}
